import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDateRangeTimestamps } from '../../../utils/analyticsUtils';
import {
  setDateRange,
  toggleEmailReport,
  setReportEmail,
  setReportFrequency,
  loadAnalyticsRequest,
  calculateFailureReasons,
} from '../../../store/slices/analyticsSlice';

export const useAnalyticsData = () => {
  const dispatch = useDispatch();
  const { dateRange, dailyData, failureReasons, topTemplates, emailReport, loading, error } = useSelector(
    (state) => state.analytics
  );
  const { wabaAccounts, wabaLoading, wabaError } = useSelector((state) => state.whatsapp);

  const [hasAttemptedWabaFetch, setHasAttemptedWabaFetch] = useState(false);

  const hasWabaAccounts = Array.isArray(wabaAccounts) && wabaAccounts.length > 0;
  const primaryWabaId = hasWabaAccounts ? (wabaAccounts[0]?.wabaId || '') : '';

  useEffect(() => {
    if (!wabaLoading && !hasWabaAccounts && !hasAttemptedWabaFetch) {
      setHasAttemptedWabaFetch(true);
      dispatch({ type: 'FETCH_WABA_IDS' });
    }
  }, [dispatch, hasWabaAccounts, wabaLoading, hasAttemptedWabaFetch]);

  useEffect(() => {
    if (!primaryWabaId) return;
    const duration = getDateRangeTimestamps(parseInt(dateRange, 10));
    dispatch(
      loadAnalyticsRequest({
        wabaId: primaryWabaId,
        duration,
      })
    );
  }, [dispatch, dateRange, primaryWabaId]);

  useEffect(() => {
    if (dailyData.length > 0) {
      dispatch(calculateFailureReasons());
    }
  }, [dispatch, dailyData]);

  const setRange = (val) => dispatch(setDateRange(val));
  const setEmailOpen = (val) => dispatch(toggleEmailReport(val));
  const setEmail = (val) => dispatch(setReportEmail(val));
  const setFrequency = (val) => dispatch(setReportFrequency(val));

  return {
    dateRange,
    dailyData,
    failureReasons,
    topTemplates,
    emailReport,
    loading,
    error,
    wabaAccounts,
    wabaLoading,
    wabaError,

    setRange,
    setEmailOpen,
    setEmail,
    setFrequency,
  };
};